<template>
    <div class="tb-box">
      <IMTable
        v-bind="$props"
        :tableTitle="title"
        :tableSubTitle="subTitle"
        :table-head.sync="tableHead"
        :table-data.sync="tableData"
        @onRowClick="onRowClick"
        @onBtns="onBtns"
      />
    </div>
</template>

<script>
export default {
  name: 'table-box',
  props: {
    title: String,
    subTitle: String,
    tableHead: Array,
    tableData: Array,
    isOrder: Boolean,
    isPage: Boolean
  },
  methods: {
    onRowClick (row) {
      this.$emit('onRowClick', row)
    },
    onBtns (item, data, index) {
      this.$emit('onBtns', item, data, index)
    }
  }
}
</script>

<style scoped>

</style>
